import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { allowedTableCellPropTypes } from '../utils/allowedPropTypes';
import DefinitionListCollection from './_DefinitionListCollection';

class Definition extends React.Component {
  constructor() {
    super();
    this.state = { isGroupExpanded: true };

    this.toggleDropdownState = this.toggleDropdownState.bind(this);
  }

  toggleDropdownState() {
    this.setState(isGroupExpanded => ({ isGroupExpanded: !isGroupExpanded }));
  }

  render() {
    const {
      props,
      state,
      toggleDropdownState
    } = this;

    const {
      nestedCells,
      cellContent
    } = props.listItemData;

    const { isGroupExpanded } = state;

    if (nestedCells !== undefined) {
      return (
        <React.Fragment>
          <dd>
            <button
              className='opener button-wrap w-auto'
              title='se detaljer'
              aria-expanded={isGroupExpanded}
              onClick={toggleDropdownState}
            >
              <FontAwesomeIcon icon={(isGroupExpanded) ? 'chevron-up' : 'chevron-down'} />
            </button>
          </dd>

          {!isGroupExpanded ? '' : (
            <dd className='dd-dropdown has-nested-data-list'>
              <DefinitionListCollection listCollectionData={nestedCells} />
            </dd>
          )}
        </React.Fragment>
      );
    }

    return (
      <dd>
        <div className='overflow-limiter'>
          {cellContent.toString()}
        </div>
      </dd>
    );
  }
}

Definition.propTypes = {
  listItemData: PropTypes.shape({
    cellContent(props, propName, componentName) {
      const cellContentProperty = props[propName];
      if (cellContentProperty && !(
        typeof (cellContentProperty) === 'string'
        || typeof (cellContentProperty) === 'object')
      ) {
        return new Error(`
          Invalid prop "${propName}" supplied to "${componentName}":
          expected "string" or "object" but "${typeof (cellContentProperty)}" was supplied`
        );
      }

      if (!cellContentProperty && !props.nestedCells) {
        return new Error(`
          Validation of prop "${propName}" supplied to "${componentName}" failed:
          either "nestedCells" or "cellContent" has to be defined and none of them was`
        );
      }
    },
    nestedCells: PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.shape(allowedTableCellPropTypes)
      )
    )
  }).isRequired
};

export default Definition;